import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import domen from "../api/domen";

export const fetchHome = createAsyncThunk("home/fetchHome", async () => {
  const [eventsRes, albumsRes, storiesRes] = await Promise.all([
    axios.get("/api/events"),
    axios.get("/api/albums"),
    axios.get("/api/story"),
  ]);

  const events = (eventsRes.data ?? []).map((e) => ({
    id: e._id,
    date: e.date,
    time: e.time,
    title: e.title,
    shortDesc: e.shortDesc,
    photo: e.photo.startsWith("http") ? e.photo : `${domen}${e.photo}`,
  }));

  const albums = (albumsRes.data ?? [])
    .map((a) => ({
      id: a._id,
      date: a.date,
      title: a.title,
      shortDesc: a.shortDesc,
      photo: a.photos?.[0]?.startsWith("http")
        ? a.photos[0]
        : `${domen}${a.photos?.[0] ?? ""}`,
    }))
    .reverse();

  const stories = (storiesRes.data ?? [])
    .map((s) => ({
      date: s.date,
      images: (s.photos ?? []).map((p) =>
        p.startsWith("https") ? p : `${domen}${p}`
      ),
    }))
    .reverse();

  const allUrls = [
    ...events.map((e) => e.photo),
    ...albums.map((a) => a.photo),
    ...stories.flatMap((s) => s.images),
  ];

  await Promise.all(
    allUrls.map(
      (src) =>
        new Promise((res) => {
          const img = new Image();
          img.onload = res;
          img.onerror = res;
          img.src = src;
        })
    )
  );

  return { events, albums, stories };
});

const homeSlice = createSlice({
  name: "home",
  initialState: {
    loading: false,
    error: null,
    events: [],
    albums: [],
    stories: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHome.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHome.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload.events;
        state.albums = action.payload.albums;
        state.stories = action.payload.stories;
      })
      .addCase(fetchHome.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default homeSlice.reducer;
